import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star-off",
  "use": "star-off-usage",
  "viewBox": "0 0 20 19.38",
  "content": "<symbol viewBox=\"0 0 20 19.38\" id=\"star-off\"><title>star-off</title><path d=\"M4.74,19.69a1.43,1.43,0,0,1-.82-.25,1.37,1.37,0,0,1-.57-1.34l.89-5.31a0,0,0,0,0,0,0L.4,8.93a1.33,1.33,0,0,1-.33-1.4,1.44,1.44,0,0,1,1.11-.92l5.24-.78,0,0L8.73,1.1a1.42,1.42,0,0,1,2.55,0l2.27,4.71a0,0,0,0,0,0,0l5.23.78a1.35,1.35,0,0,1,.79,2.3l-3.83,3.82a.06.06,0,0,0,0,.05l.89,5.29a1.36,1.36,0,0,1-.56,1.34,1.45,1.45,0,0,1-1.5.09L10,17.06l0,0L5.42,19.52A1.43,1.43,0,0,1,4.74,19.69ZM10,1.49a.23.23,0,0,0-.21.12L7.51,6.32A1.2,1.2,0,0,1,6.59,7l-5.22.78a.26.26,0,0,0-.19.15.17.17,0,0,0,.05.17l3.83,3.82A1.23,1.23,0,0,1,5.41,13l-.89,5.32a.19.19,0,0,0,.09.19.27.27,0,0,0,.26,0L9.42,16a1.27,1.27,0,0,1,.59-.15,1.13,1.13,0,0,1,.59.16l4.54,2.44a.27.27,0,0,0,.27,0,.19.19,0,0,0,.08-.18L14.6,13a1.24,1.24,0,0,1,.34-1.07L18.77,8.1a.18.18,0,0,0,0-.18.21.21,0,0,0-.17-.13L13.41,7a1.2,1.2,0,0,1-.92-.68L10.22,1.61A.24.24,0,0,0,10,1.49Z\" transform=\"translate(0 -0.31)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/star-off.svg
// module id = mUd6
// module chunks = 264